type Props = {
  eyebrow?: string;
  title: string;
  accent?: string;
  desc?: string;
  align?: "center" | "left";
};

export default function SectionHeading({ eyebrow, title, accent, desc, align = "center" }: Props) {
  return (
    <div
      className={`mb-8 md:mb-12 ${
        align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl text-left"
      }`}
    >
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-sm text-accent-800">
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading mt-4 text-3xl md:text-4xl leading-tight text-foreground-950 text-balance">
        {title}
        {accent && <span className="text-primary-600"> {accent}</span>}
      </h2>
      {desc && <p className="mt-4 text-base leading-relaxed text-foreground-600">{desc}</p>}
    </div>
  );
}